import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import GlobalContainer from '@ui/container/global-container';
import { ESortOrderMap, SortDirection } from '@ui/buttons/sort-button/types';
import CastHeaderColumn from '../crew-content/cast-header-column';

const CastContentTableHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleSortClick = useCallback(
    (type: string) => (_label: string, direction: SortDirection) => {
      setSearchParams((prev) => {
        const paramsCopy = new URLSearchParams(prev);
        paramsCopy.delete('sortCastBy');
        paramsCopy.delete('sortCastOrder');
        paramsCopy.set('cast-page', '1');
        if (direction !== SortDirection.none) {
          paramsCopy.set('sortCastBy', type);
          const order = direction === SortDirection.down ? ESortOrderMap.desc : ESortOrderMap.asc;
          paramsCopy.set('sortCastOrder', order.toString());
        }
        return paramsCopy;
      });
    },
    [setSearchParams]
  );

  const getSortDirection = useCallback(
    (type: string): SortDirection => {
      const sortOrderParam = searchParams.get('sortCastOrder');
      const sortByParam = searchParams.get('sortCastBy');
      if (type !== sortByParam) {
        return SortDirection.none;
      }

      if (!sortOrderParam || isNaN(Number(sortOrderParam))) {
        return SortDirection.none;
      }

      const sortOrderParamNum = Number(sortOrderParam);

      if (sortOrderParamNum === ESortOrderMap.asc) {
        return SortDirection.up;
      }
      if (sortOrderParamNum === ESortOrderMap.desc) {
        return SortDirection.down;
      }

      return SortDirection.none;
    },
    [searchParams]
  );

  return (
    <>
      <CastHeaderColumn
        name="NAME"
        onSortClick={handleSortClick('name')}
        activeSortOrder={{ name: 'NAME', direction: getSortDirection('name') }}
      />
      <CastHeaderColumn
        name="EMAIL"
        onSortClick={handleSortClick('email')}
        activeSortOrder={{ name: 'EMAIL', direction: getSortDirection('email') }}
      />
      <CastHeaderColumn
        name="ROLE"
        onSortClick={handleSortClick('role')}
        activeSortOrder={{ name: 'ROLE', direction: getSortDirection('role') }}
      />
      <CastHeaderColumn
        name="STATUS"
        onSortClick={handleSortClick('status')}
        activeSortOrder={{ name: 'STATUS', direction: getSortDirection('status') }}
      />
      <th>
        <GlobalContainer css="display: inline-block;" />
      </th>
    </>
  );
};

export default CastContentTableHeader;
